import { useMutation } from '@tanstack/react-query'
import { post } from './client'
import type { components } from './schema.gen'

/** Resposta do componente `PageFeedback` (@wp-one/ui): 👍 ou 👎. */
export type FeedbackVote = 'like' | 'dislike'

type FeedbackBody = components['schemas']['FeedbackPaginaRequest']

/**
 * Registra o feedback (👍/👎) de uma página no `POST /one/feedback`.
 *
 * `pagina` é uma CHAVE ESTÁVEL da página (ex.: 'one:documentos'), no padrão
 * `<modulo>:<pagina>` — nunca o pathname cru com ids. O voto do componente é
 * mapeado para o contrato da API: like → 'positivo', dislike → 'negativo'.
 *
 * Retorna o handler pronto para o `onFeedback` do `PageFeedback`. O envio é
 * "dispare e esqueça": o componente já trava após a resposta e mostra o
 * agradecimento; um erro de rede não atrapalha a tela (o 401 é tratado pelo
 * handler global do QueryClient, como em qualquer mutação).
 */
export function usePageFeedback(pagina: string): (value: FeedbackVote) => void {
  const mutation = useMutation({
    mutationFn: (voto: FeedbackBody['voto']) =>
      post('/one/feedback', { pagina, voto } satisfies FeedbackBody),
  })
  return (value) => {
    mutation.mutate(value === 'like' ? 'positivo' : 'negativo')
  }
}
